import React, {useEffect, useState} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  resources: {id: string; title: string}[]
  showAll: boolean
  toggleShow: () => void
}

export const ResourceBadge: React.FC<Props> = ({resources, showAll, toggleShow}) => {
  const [isTooltipShown, setIsTooltipShown] = useState(false)

  useEffect(() => {
    if (isTooltipShown) {
      document.body.style.overflowX = 'hidden'
    } else {
      document.body.style.overflowX = ''
    }
  }, [isTooltipShown])

  return (
    <>
      <span className='badge px-3 rounded-pill me-1 fs-7' style={{border: '2px solid #E1E1E1'}}>
        {resources[0].title.trim()}
      </span>

      {resources.length > 1 && !showAll && (
        <OverlayTrigger
          placement='right'
          overlay={
            <Tooltip
              id='tooltip-resources'
              style={
                {
                  '--bs-tooltip-max-width': 'auto',
                  whiteSpace: 'pre-line',
                } as React.CSSProperties
              }
            >
              <ul className='d-flex flex-column gap-1 m-0 p-0 ps-4'>
                {resources.slice(1).map((resource) => (
                  <li key={resource.id} className='fs-7 fw-medium text-start'>
                    {resource.title.trim()}
                  </li>
                ))}
              </ul>
            </Tooltip>
          }
        >
          <button
            className='btn btn-icon btn-sm'
            onMouseEnter={() => setIsTooltipShown(true)}
            onMouseLeave={() => setIsTooltipShown(false)}
          >
            <span className='badge px-3 rounded-pill' style={{border: '2px solid #E1E1E1'}}>
              +{resources.length - 1}
            </span>
          </button>
        </OverlayTrigger>
      )}

      {showAll &&
        resources.slice(1).map((resource, idx) => (
          <div key={resource.id} className='d-flex flex-stack my-1'>
            <span className='text-muted me-2 fs-7 fw-semibold'>
              <span className='badge px-3 rounded-pill fs-7' style={{border: '2px solid #E1E1E1'}}>
                {resource.title.trim()}
              </span>
            </span>
          </div>
        ))}
    </>
  )
}
